import React from "react";
import "../../styles/Cohort.css";

const Cohort = () => {
  const stages = [
    {
      number: "01",
      title: "Crawl (-2 to +2 years)",
      gif: "/assets/gifs/crawl.gif",
      description:
         "For students and early learners, building core semiconductor knowledge, foundational concepts, and industry-ready skills.",
    },
    {
      number: "02",
      title: "Climb and Consolidate (+2 to 7 years)",
      gif: "/assets/gifs/climb.gif",
      description:
       "For women in early industry years, strengthening technical depth and career direction.",
    },
    {
      number: "03",
      title: "Cultivate and Craft (7 to 15 years)",
      gif: "/assets/gifs/cultivate.gif",
      description:
        "For women advancing into senior roles, focusing on leadership, decision-making, collaboration, and long-term growth.",
    },
    {
      number: "04",
      title: "Command and Contribute (15+ years)",
      gif: "/assets/gifs/command.gif",
      description:
       "For experienced women leaders, influencing industry growth through mentorship and leadership."
    },
    {
      number: "05",
      title: "Comeback (Re-entry)",
      gif: "/assets/gifs/climb.gif",
      description:
        "For women returning after a career break, supporting skill refresh, confidence rebuilding, and smooth industry re-entry.",
    },
  ];

  return (
    <section className="home-cohort-section">
      <div className="container">
        {/* Header */}
        <div className="home-cohort-header">
          <h2 className="cohort-main-title wise-secondary-gradient">
            OUR COHORTS
          </h2>
          <p className="home-cohort-subtitle">
           Structured career-stage communities designed to support women
                from early learning to leadership and re-entry within the
                semiconductor ecosystem.
          </p>
        </div>

        {/* Cards */}
        <div className="cohort-row">
          {stages.map((item, index) => (
            <div key={index} className="cohort-card hover-effect-only">
              <div className="cohort-top">
                <span className="cohort-number">[{item.number}]</span>
                <img
                  src={item.gif}
                  alt={item.title}
                  className="cohort-gif"
                />
              </div>

              <div className="home-cohort-content">
                <h4 className="home-cohort-title mb-3">
                  {item.title}
                </h4>
                <p className="home-cohort-description">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cohort;